import React, { useCallback, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useNotification } from 'hooks'
import { useJobQuery } from '../../api'
import { InfoItems } from 'components/core-ui/InfoItems'
import { Box, CircularProgress } from '@mui/material'
import style from '../../jobs.modules.scss'
import ActionComponents from '../../components/ActionComponents'
import { DeleteModal } from '../components/DeleteModal'
import { formatUIDateTime } from 'utils/helpers'
import EditJobModal from '../EditJob/EditJobModal'

const JobDetails: React.FC = () => {
    const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)
    const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
    const { canEdit, canDelete } = { canEdit: true, canDelete: false }

    const { id } = useParams<{ id: string }>()
    const { showNotification } = useNotification()
    const navigate = useNavigate();
    const { data: job, isLoading, refetch: refetchJob } = useJobQuery(showNotification, Number(id), shouldRefreshData)

    const openEditModal = useCallback(() => setIsEditModalOpen(true), [])
    const closeEditModal = useCallback(() => setIsEditModalOpen(false), [])

    const openDeleteModal = useCallback(() => setIsDeleteModalOpen(true), [])
    const closeDeleteModal = useCallback(() => {
        setIsDeleteModalOpen(false);
        navigate(-1);
    }, [])

    if (isLoading) return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
    if (!job) return <div>Job not found</div>

    return (
        <div className={style.mainContainer}>
            {isEditModalOpen && (
                <EditJobModal
                    isModalOpen={isEditModalOpen}
                    onModalClose={closeEditModal}
                    jobId={job.id}
                    onSuccess={refetchJob}
                />
            )}
            {canDelete && (
                <DeleteModal
                    isModalOpen={isDeleteModalOpen}
                    closeModal={closeDeleteModal}
                    itemId={job.id}
                    setShouldRefreshData={setShouldRefreshData}
                />
            )}

            <Box className={style.flexContainer}>
                <Box sx={{ flex: 1 }}>
                    <InfoItems
                        itemsPerRow={1}
                        items={[
                            { name: job.jobTitle, label: 'Job Name:' },
                            { name: job.jobCategory?.name || job.jobCategory?.id + ``, label: 'Job Category:' },
                            { name: job.jobDetails.name, label: 'Employee Category:' },
                            { name: job.active ? 'Active' : 'Inactive', label: 'Status:' },
                            { name: job.createdBy, label: 'Created By:' },
                            { name: formatUIDateTime(job.createdDate), label: 'Created Date:' },
                            { name: job.lastModifiedBy, label: 'Modified By:' },
                            { name: formatUIDateTime(job.lastModifiedDate), label: 'Modified Date:' },
                            { name: job.id.toString(), label: 'Job ID:' }
                        ]}
                        title={"Job Details"}
                        actionComponents={<ActionComponents canDelete={false} canEdit={canEdit} openDeleteModal={openDeleteModal} openEditModal={openEditModal} />}
                    />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <InfoItems
                        itemsPerRow={1}
                        items={[
                            { name: job.jobCategory?.name, label: 'Name:' },
                            { name: job.jobCategory?.code, label: 'ISIM Code:' },
                            { name: job.jobCategory?.description, label: 'Description:' },
                            { name: job.jobCategory?.active ? "Active" : "Inactive", label: 'Status:' },
                            { name: job.jobCategory?.id + ``, label: 'Category ID:' },
                        ]}
                        title={"Job Category"}
                    />
                </Box>
            </Box>
        </div>
    )
}

export default JobDetails